// просто текст чтобы bitrix cli правильно выставил кодировку
import Application from "./components/application";
import { BitrixVue } from "ui.vue3";

import store from "./store/store";
// import router from "./router/router";

export class Statements {
    #app;
    root_node_id;
    root_node;TechnicalFailureStatementStepThree
    app_type;
    bx;
    php_vars;

    constructor({ root_node_id, app_type, app_params, bx, php_vars}) {
        this.root_node_id = root_node_id;
        this.root_node = document.querySelector(root_node_id);
        this.app_type = app_type;
        this.bx = bx;
        this.php_vars = php_vars;
    }

    start() {
        this.attachTemplate();
    }

    attachTemplate() {
        const context = this;

        this.#app = BitrixVue.createApp({
            name: "Statements",

            components: {
                Application,
            },

            data() {
                return {};
            },

            beforeCreate() {
                this.$bitrix.Application.set(context);
            },

            template: /*html*/ `<Application />`,
        });


        this.#app.use(store);
        // this.#app.use(router);
        this.#app.mount(this.root_node);
    }
}
